<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-invoices-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'InvoiceSearch',
  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreInvoicesView: () => import('../components/core/InvoicesView'),
    CoreFooter: () => import('../components/core/Footer'),
  },
  data: () => ({
    expandOnHover: false,
  }),
}
</script>
